import { inject, injectable } from 'inversify';
import { ArmyListMapper } from '@Mapper/builder/army-list.mapper';
import { TYPES } from '@Types';
import { RequestAction, RequestFailure } from '../RequestAction';
import { RequestArmyListsSuccess } from './response';
import { Locale } from '../locale';
import { ApiClient } from '@Api';

@injectable()
export class SearchRepository {
  @inject(TYPES.ArmyListMapper) private _armyListMapper!: ArmyListMapper;
  @inject(TYPES.Api.ApiClient) private _apiClient!: ApiClient;
  @inject(TYPES.Locale) private _locale!: Locale;

  public async searchArmyList({
    armyId,
    min,
    max,
  }: {
    armyId: number;
    min: number;
    max: number;
  }): Promise<RequestAction> {
    try {
      const armyListsDto = await this._apiClient.builder.searchArmyList({
        locale: this._locale.getlocale(),
        armyId: armyId,
        min: min,
        max: max,
      });
      return new RequestArmyListsSuccess({
        payload: armyListsDto.map((item) => this._armyListMapper.map(item)),
      });
    } catch (error: any) {
      return new RequestFailure({ error: error });
    }
  }
}
